import React, { useEffect, useState } from "react";
import {
  Checkbox,
  CircularProgress,
  Grid,
  Input,
  Switch,
  useTheme,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { checkMaterial } from "Helpers/checkLabel";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import showNotify from "Helpers/Notify";

let get_loading = false;

const MobileTable = ({
  data,
  columns,
  props,
  noTitle,
  title,
  currentPage,
  sizePerPage,
  totalSize,
  onTableChange,
  showPagination,
  loading,
}) => {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [rdata, setRdata] = useState([]);
  const [mdata, setMdata] = useState([]);
  const [stion, setStion] = useState([]);
  const [containImage, setContainImage] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllStatus, setSelectAllStatus] = useState(false);

  useEffect(() => {
    if (columns && data && data.length !== 0) {
      try {
        let new_form = data.map((item, index) => {
          let _data = [];
          let uniqId = index * 100 + Date.now();
          columns
            .filter((col) => col.dataField !== "num" && col.dataField !== "Row")
            .filter((col) => !col.hidden)
            .map((col, index) => {
              let value = "";
              if (col.formatter)
                value = col.formatter(item[col.dataField], item, true);
              else value = item[col.dataField];
              if (value === 0) value = value.toString();
              _data.push({
                key: col.text,
                value,
                uniqId: `${uniqId}_C${index}`,
                mode: col.headerClasses ? col.headerClasses : "normal",
                editable: col.editable
                  ? col.editable === true
                    ? true
                    : col.editable(null, item)
                  : false,
                editableValue: col.editable ? value : null,
                src: item,
                column: col,
                editMode: false,
                onValueChange: col.editable
                  ? props.cellEdit.options.beforeSaveCell
                  : null,
                checkbox:
                  col.editor && col.editor.type === "checkbox"
                    ? {
                        items: [{ value: item[col.dataField], key: "active" }],
                        value: item[col.dataField],
                      }
                    : null,
              });
            });
          if (props && props.selectRow) {
            setSelectAll(props.selectRow.onSelectAll ? true : false);
            setStion(props.selectRow.selected ? props.selectRow.selected : []);
            _data.push({
              key: `btn-${props.selectRow.mode}`,
              value: `btn-${props.selectRow.mode}`,
              mode: props.selectRow.mode,
              src: item,
              uniqId,
            });
          }
          return _data;
        });
        setContainImage(
          columns.find((col) => col.dataField === "Image") ? true : false
        );
        if (currentPage === 1) {
          setMdata(new_form);
          setRdata(data);
        } else {
          setMdata([...mdata, ...new_form]);
          setRdata([...rdata, ...data]);
        }
      } catch (err) {
        console.log("Mobile table Error: ", err);
      }
    } else if (data.length === 0) setMdata([]);
  }, [data]);

  useEffect(() => {
    if (!loading && currentPage !== 0 && sizePerPage !== 0 && totalSize !== 0) {
      const mac = document.getElementById("main-admin-content");
      const cdm = document.getElementById("content-dialog-manager");
      const cdmi = document.getElementById("content-dialog-manager-inner");
      mac && mac.addEventListener("scroll", handleScroll);
      cdm && cdm.addEventListener("scroll", handleDialogScroll);
      cdmi && cdmi.addEventListener("scroll", handleInnerDialogScroll);
      return () => {
        mac && mac.removeEventListener("scroll", handleScroll);
        cdm && cdm.removeEventListener("scroll", handleDialogScroll);
        cdmi && cdmi.removeEventListener("scroll", handleInnerDialogScroll);
      };
    }
  }, [currentPage, sizePerPage, totalSize, loading]);

  const get_more_row = () => {
    if (get_loading) return;
    get_loading = true;
    onTableChange("pagination", { page: +(currentPage + 1), sizePerPage });
    setTimeout(() => {
      get_loading = false;
    }, 500);
  };

  const handleScroll = () => {
    const mac = document.getElementById("main-admin-content");
    const totalPage = Math.ceil(totalSize / sizePerPage);
    if (
      window.innerWidth <= 768 &&
      data &&
      data.length !== 0 &&
      mac.scrollTop >= mac.scrollHeight - mac.offsetHeight - 10 &&
      currentPage < totalPage
    ) {
      get_more_row();
      // onTableChange("pagination", { page: +(currentPage + 1), sizePerPage });
    }
  };

  const handleDialogScroll = () => {
    const cdm = document.getElementById("content-dialog-manager");
    const totalPage = Math.ceil(totalSize / sizePerPage);
    if (
      data &&
      data.length !== 0 &&
      cdm.scrollTop >= cdm.scrollHeight - cdm.offsetHeight - 10 &&
      currentPage < totalPage
    ) {
      get_more_row();
      // onTableChange("pagination", { page: +(currentPage + 1), sizePerPage });
    }
  };

  const handleInnerDialogScroll = () => {
    const cdmi = document.getElementById("content-dialog-manager-inner");
    const totalPage = Math.ceil(totalSize / sizePerPage);
    if (
      data &&
      data.length !== 0 &&
      cdmi.scrollTop >= cdmi.scrollHeight - cdmi.offsetHeight - 10 &&
      currentPage < totalPage
    ) {
      get_more_row();
      // onTableChange("pagination", { page: +(currentPage + 1), sizePerPage });
    }
  };

  const onEditToggle = (item, enable_save = true) => {
    setMdata(
      mdata.map((items) => {
        items.map((inner) => {
          if (inner.uniqId === item.uniqId)
            if (inner.column.dataField === item.column.dataField) {
              const editMode = !inner.editMode;
              inner.editMode = editMode;
              if (!editMode && enable_save) {
                const oldValue = convertToEnglishNumber(
                  inner.value.toString().replaceAll(",", "")
                );
                const newValue = convertToEnglishNumber(
                  inner.editableValue.toString().replaceAll(",", "")
                );
                if (oldValue !== newValue)
                  inner.onValueChange(
                    oldValue,
                    newValue,
                    inner.src,
                    inner.column,
                    (e) => {}
                  );
              }
              inner.editableValue = inner.value;
            }
          return inner;
        });
        return items;
      })
    );
  };

  const onChangeTextValue = (e, item) => {
    setMdata(
      mdata.map((items) => {
        items.map((inner) => {
          if (
            inner.uniqId === item.uniqId &&
            inner.column.dataField === item.column.dataField
          ) {
            const value = e.target.value;
            if(value !== "" && inner.column.inputType === "number") {
              const enValue = convertToEnglishNumber(value);
              const _test = /^\d+$/.test(enValue);
              if (_test) {
                inner.editableValue = e.target.value;
              } else {
                showNotify({
                  text: t("typeNumberError"),
                  customClass: "error",
                });
              }
            } else {
              inner.editableValue = e.target.value;
            }
          }
          return inner;
        });
        return items;
      })
    );
  };

  const onEditCheckbox = (item) => {
    mdata.map((items) => {
      items.map((inner) => {
        if (
          inner.src.Id === item.src.Id &&
          inner.column.dataField === item.column.dataField
        )
          inner.onValueChange(
            inner.checkbox.value,
            !inner.checkbox.value,
            inner.src,
            inner.column
          );
      });
    });
  };

  const checkStatus = (i) => {
    if (stion.length !== 0) {
      if (stion.includes(i[0].src.Id)) return true;
      else return false;
    } else return false;
  };

  const onSelectOneCheckbox = (row, checked) => {
    if (checked) setStion([...stion, row.Id]);
    else setStion(stion.filter((i) => i !== row.Id));
    props.selectRow.onSelect(row, checked);
  };

  const onSelectOneRadio = (row) => {
    setStion([row.Id]);
    props.selectRow.onSelect(row);
  };

  const onSelectAll = (e) => {
    setSelectAllStatus(e.target.checked);
    if (e.target.checked) setStion(rdata.map((i) => i.Id));
    else setStion([]);
    props.selectRow.onSelectAll(e.target.checked, rdata);
  };

  useEffect(() => {
    if (rdata.length !== 0) {
      if (selectAllStatus && stion.length !== rdata.length)
        setSelectAllStatus(false);
      if (!selectAllStatus && stion.length === rdata.length)
        setSelectAllStatus(true);
    }
  }, [stion, rdata]);

  return (
    <div id="mobile-table" className="mobile-mode">
      {selectAll && (
        <div className="mobile-table-select-all">
          <Checkbox
            id="select-all-checkbox"
            checked={selectAllStatus}
            onChange={onSelectAll}
          />
          <label htmlFor="select-all-checkbox" className="m-0">
            {t("selectAll")}
          </label>
        </div>
      )}
      {mdata && mdata.length !== 0 ? (
        mdata.map((i, iindex) => {
          return (
            <div
              key={`tbl-data-${iindex}`}
              className={`table-row ${checkStatus(i) ? "selected-row" : ""} ${
                direction === "rtl" ? "text-right" : "text-left"
              }`}
            >
              {i
                .filter((item) => item.mode === "checkbox")
                .map((item, index) => {
                  return (
                    <div
                      className="checkbox-section"
                      key={`main-checkbox-${iindex}-${index}`}
                    >
                      <div className="inner-input">
                        <Checkbox
                          id={`checkbox-${iindex}-${index}`}
                          checked={checkStatus(i)}
                          onChange={(e) =>
                            onSelectOneCheckbox(
                              item.src,
                              e.currentTarget.checked
                            )
                          }
                        />
                        <label
                          htmlFor={`checkbox-${iindex}-${index}`}
                          className="m-0"
                        >
                          {t("select")}
                        </label>
                      </div>
                      {containImage && (
                        <div className="unit-name">
                          <Icons.CardText />
                          <span>{item.src.Name}</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              {!containImage ? (
                <div
                  className={`data-section ${
                    direction === "rtl" ? "text-right" : "text-left"
                  }`}
                >
                  {i
                    .filter(
                      (item) =>
                        ![
                          "checkbox",
                          "radio",
                          "action",
                          "actionBtn",
                          "Lock",
                        ].includes(item.mode)
                    )
                    .filter((item) => item.value)
                    .map((item, index) => {
                      return (
                        <div
                          key={`${item.key}-${index}`}
                          className={`inner-data ${
                            item.editMode ? "editMode" : ""
                          }`}
                        >
                          <span className="text-nowrap d-none d-sm-block">
                            {item.key === "" ? (
                              ""
                            ) : (
                              <>
                                {item.key}
                                {":"}
                              </>
                            )}
                          </span>
                          <div
                            className={`inner-field-data ${
                              item.editable ? "editable" : ""
                            }`}
                          >
                            {!item.editMode && (
                              <p
                                className={`m-0 ${
                                  item.column?.classes
                                    ? item.column.classes
                                    : ""
                                }`}
                              >
                                {item.value}
                              </p>
                            )}
                            {item.editable &&
                              item.column.editorClasses === "inputEditor" &&
                              (!item.editMode ? (
                                <MuiIconButton
                                  key={`edit-key-${item.uniqId}`}
                                  className="warning-fill"
                                  icon={<Icons.Pencil />}
                                  title={t("virayesh")}
                                  onClick={() => onEditToggle(item)}
                                />
                              ) : (
                                <div
                                  key={`edit-section-${item.uniqId}`}
                                  className="d-flex flex-row justify-content-between flex-grow-1"
                                >
                                  <input
                                    name={`edit-input-${item.uniqId}`}
                                    onChange={(e) => onChangeTextValue(e, item)}
                                    type={item.column.inputType}
                                    inputMode={
                                      item.column.inputType === "number"
                                        ? "decimal"
                                        : undefined
                                    }
                                    value={item.editableValue}
                                  />
                                  <div className="d-flex flex-row">
                                    <MuiIconButton
                                      className="warning-fill"
                                      icon={<Icons.Floppy />}
                                      title={t("zakhire")}
                                      onClick={() => onEditToggle(item)}
                                    />
                                    <MuiIconButton
                                      className="danger-fill"
                                      icon={<Icons.XLg />}
                                      title={t("enseraf")}
                                      onClick={() => onEditToggle(item, false)}
                                    />
                                  </div>
                                </div>
                              ))}
                            {item.editable &&
                              item.column.editor &&
                              item.column.editor.type === "checkbox" && (
                                <Switch
                                  className={`switcher ${direction}`}
                                  color="primary"
                                  checked={!item.src.Disable}
                                  onClick={() => onEditCheckbox(item)}
                                />
                              )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div className="image-data-section">
                  {i
                    .filter((item) => item.value && item.mode === "image")
                    .map((item, index) => {
                      return (
                        <>
                          <div
                            key={`${item.key}-${index}`}
                            className="inner-image"
                          >
                            {item.value}
                            <div className="size-show text-left">
                              <p>{`${item.src.WUnit}x${item.src.HUnit} (${
                                item.src.CountUnit
                              } ${t("_count")})`}</p>
                              {item.src.Struct && (
                                <p>{checkMaterial(item.src.Struct)}</p>
                              )}
                              {item.src.TypeUnit && (
                                <p>{checkMaterial(item.src.TypeUnit)}</p>
                              )}
                            </div>
                          </div>
                          <div
                            className={`data-section-inner ${
                              direction === "rtl" ? "text-right" : "text-left"
                            }`}
                          >
                            {i
                              .filter(
                                (inner_item) =>
                                  inner_item.column?.dataField === "Location"
                              )
                              .map((inner_item) => {
                                return (
                                  <>
                                    <div className="text-nowrap d-flex flex-row g-2">
                                      {inner_item.key === "" ? (
                                        ""
                                      ) : (
                                        <>
                                          {inner_item.key}
                                          {":"}
                                        </>
                                      )}
                                      <p
                                        className={`m-0 ${inner_item.column?.classes}`}
                                        style={{ fontWeight: 500 }}
                                      >
                                        {inner_item.value}
                                      </p>
                                    </div>
                                  </>
                                );
                              })}
                            {i
                              .filter(
                                (inner_item) =>
                                  inner_item.column?.dataField ===
                                  "GroupProfile"
                              )
                              .map((inner_item) => {
                                return (
                                  <p
                                    key={`clmn-GroupProfile-${inner_item.value}`}
                                    className={`m-0 ${item.column?.classes}`}
                                    style={{ fontWeight: 500 }}
                                  >
                                    {inner_item.value}
                                  </p>
                                );
                              })}
                          </div>
                        </>
                      );
                    })}
                </div>
              )}
              {i.filter((item) =>
                ["radio", "action", "actionBtn"].includes(item.mode)
              ).length !== 0 && (
                <div className="btns-section">
                  {i
                    .filter((item) =>
                      ["radio", "action", "actionBtn"].includes(item.mode)
                    )
                    .map((item, index) => {
                      return item.key === "btn-radio" ? (
                        <MuiButton
                          key={`${item.key}-${item.src.Id}-${index}`}
                          color="secondary"
                          title={t("select")}
                          disabled={item.src.IsLock}
                          onClick={() => onSelectOneRadio(item.src)}
                        />
                      ) : (
                        <div
                          key={`selfItem-${item.src.Id}-${index}`}
                          className="text-center"
                        >
                          {item.value}
                        </div>
                      );
                    })}
                </div>
              )}
              {i.filter((item) => ["Lock"].includes(item.mode)).length !==
                0 && (
                <div className="Lock-section">
                  {i
                    .filter((item) => ["Lock"].includes(item.mode))
                    .map((item, index) => {
                      return (
                        <div
                          key={`selfItem-${item.src.Id}-${index}`}
                          className="mobile-table-project-Lock"
                        >
                          {item.value}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="no-data-exist">
          <span className="text-center">{t("noData2Display")}</span>
        </div>
      )}
      {!loading ? (
        mdata &&
        showPagination &&
        mdata.length !== 0 && (
          <div className="table-counting-info">
            {/* {mdata ? mdata : 'null'} */}
            <span>{`${mdata ? mdata.length : "..."}/${
              totalSize ? totalSize : "..."
            }`}</span>
          </div>
        )
      ) : (
        <div className="w-100 d-flex flex-row justify-content-center align-items-center mb-4">
          <CircularProgress color="inherit" size={40} thickness={2} />
        </div>
      )}
    </div>
  );
};

export default MobileTable;
